import type { MoneyInputValue } from '@/interfaces';
import { MoneyHelper } from '@/utils';
import { NInputNumber } from 'naive-ui';
import { defineComponent, ref, watch } from 'vue';
import currency from 'currency.js';

export const AppInputMoney = defineComponent({
	props: {
		modelValue: Number,
		placeholder: {
			type: String,
			default: '0,00',
		},
		disabled: Boolean,
		readonly: Boolean,
	},

	emits: ['update:value', 'update:modelValue', 'blur'],

	setup(props, { emit }) {
		const refValue = ref<number | undefined>();

		if (props.modelValue) {
			refValue.value = props.modelValue;
		}

		const handleInput = (value: any) => {
			// Campo limpo não é zero. O NInputNumber é `clearable` e manda null tanto no botão de
			// limpar quanto quando o `parse` não acha número no texto esvaziado — e currency(null).value
			// é 0. Emitir 0 aqui apaga a diferença entre "não informado" e "informado como zero", e rio
			// abaixo isso vira dinheiro: a apuração do estorno de cancelamento resolve cada dedução com
			// `override ?? regra`, e 0 não é null, então limpar a Multa ou o Tempo de garantia zerava a
			// dedução em vez de devolver a regra automática, estornando a maior.
			if (value === null || value === undefined || value === '') {
				emit('update:value', undefined);
				emit('update:modelValue', undefined);
				return;
			}

			const parsed = currency(value, { separator: '.', decimal: ',' });
			emit('update:value', parsed.value);
			emit('update:modelValue', parsed.value);
		};

		watch(
			() => props.modelValue,
			// `!= null` cobre null e undefined de uma vez (a condição anterior era
			// `!= null || != undefined`, verdadeira para qualquer valor não nulo — mesmo efeito, só que
			// ilegível). Tem de continuar sendo teste de nulidade e não de verdade: 0 é valor digitado.
			(value) => (value != null ? (refValue.value = value) : (refValue.value = undefined)),
		);

		return () => (
			<NInputNumber
				style="width: 100%"
				disabled={props.disabled}
				readonly={props.readonly}
				clearable
				placeholder={props.placeholder}
				v-model:value={refValue.value}
				onUpdateValue={handleInput}
				onBlur={(e) => emit('blur', e)}
				v-maska
				input-props={{
					//value: refValue.value,
					'data-maska': '9.99#,##',
					'data-maska-tokens': '9:[0-9]:repeated',
					'data-maska-reversed': true,
					inputmode: 'numeric',
				}}
				parse={MoneyHelper.toMachineFormat}
				format={MoneyHelper.toHumanFormat}
			>
				{{ prefix: () => 'R$' }}
			</NInputNumber>
		);
	},
});

export type { MoneyInputValue };

export default AppInputMoney;
